import type { AiChatMessage } from "@productlane/lib/src/ai"

// The newest answer sits right above the composer, so it carries no rating row;
// earlier answers reveal theirs on hover.
export function actionlessAnswerId(
	messages: AiChatMessage[] | null,
): string | null {
	const last = messages?.[messages.length - 1]
	if (!last || last.role !== "assistant") return null
	if (!last.processed || !last.content) return null
	return last.id
}
